var React = require('react');

function IcShareEmailCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFD2D2","fillOpacity":".01","d":"M0 0h32v32H0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31 16c0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15zM8 11a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H9a1 1 0 01-1-1V11zm2 9v-6.826l5.35 4.585a1 1 0 001.3 0L22 13.174V20H10zm6-4.317L11.703 12h8.594L16 15.683z","fill":"currentColor","key":1})]);
}

IcShareEmailCircle.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = IcShareEmailCircle;

IcShareEmailCircle.default = IcShareEmailCircle;
